import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import customConfig from "../../../config";
import { selectMenuProps } from "../../../utils/selectMenuProps";
import { convertCapabilityName, isJsonParseSuccessful, isJsonStringifySuccessful, validateJSONData } from "../../../utils/general";
import Grid2 from "@mui/material/Grid2";
import FormInput from "../../Common/FormInputs/MuiTextField";

const selectInputSx = { height: "3rem", width: "100%" };
const capabilityListDropdownSx = { marginTop: "20px", marginBottom: "20px" };
const addCapabilityButtonSx = { marginTop: "45px", marginBottom: "20px" };
const capabilityCardSx = { marginBottom: "15px", backgroundColor: "#f2f2f2" };
const attributeKeySx = { marginRight: '20px' };
const attributeValuesSx = { width: "100%" };
const deleteCapabilityCardButtonSx = { float: "right" };
const customValueKeySx = { marginLeft: "20px !important" };

const CONFIG = {
  customJson: {
    label: "Custom Capability JSON",
    placeholder: `e.g., {"capability": "PowerfulMode","attributes": [{"key": "acpm"}]} `,
    rows: 4,
    helpText: "Valid JSON format is required",
  },
};

const DeviceModelControlCapability = ({
    productCategory,
    isDeviceModelAddedUsingFileUpload,
    editDeviceModel,
    deviceModelData,
    triggerAddNewDeviceModel,
    addDeviceControlCapabilties,
    ModelData: { deviceModelsMetadata },
    channelAndSwitchDeviceTypes,
    areAllCustomJsonValidCheck
}) => {
    // const [controlCapabiltiesList, setControlCapabiltiesList] = useState(Object.keys(deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities ?? {}).sort())
    const customCapabilityName = "CustomCapability";
    const [customCapabilityCount, setCustomCapabilityCount] = useState(1);
    const [controlCapabiltiesList, setControlCapabiltiesList] = useState(() => {
        const capabilities = Object.keys(
            deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities ?? {}
        ).sort();

        return Array.from(
            new Set([customCapabilityName, ...capabilities])
        );
    });
    const [selectedControlCapability, setSelectedControlCapability] = useState(Object.keys(deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities ?? {}).sort()?.[0] ?? "")
    const [addedControlCapabilities, setAddedControlCapabilities] = useState([])
    const [controlCapabilitiesAttributes, setControlCapabilitiesAttributes] = useState({})

    const [controlCapabilitySelectedValueType, setControlCapabilitySelectedValueType] = useState({})

    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const areAllCustomJsonValid = (errorsObj) => {
        return Object.values(errorsObj).every(error => error === "");
    };

    useEffect(() => {
        if (deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities ?? null) {

            let controlCapabilities = deviceModelsMetadata.categories[productCategory].controlCapabilities
            for (let capabilityName in controlCapabilities) {
                for (let index in controlCapabilities[capabilityName].attributes) {
                    if (controlCapabilities[capabilityName].attributes[index].valueType instanceof Object &&
                        Array.isArray(controlCapabilities[capabilityName].attributes[index].valueType)
                    ) {
                        controlCapabilitySelectedValueType[controlCapabilities[capabilityName].attributes[index].key] = ""
                    }
                }
            }

            setControlCapabilitySelectedValueType(controlCapabilitySelectedValueType)
        }
    }, [])

    useEffect(() => {
        let ctrlCapabilitiesAttributes = {}

        if (editDeviceModel || isDeviceModelAddedUsingFileUpload) {
            let controlCapabilities = deviceModelData["controlCapabilities"]
            for (let capability of controlCapabilities) {
                let capabilityName = capability['capability']
                if( (deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities) && !([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities)){
                    ctrlCapabilitiesAttributes[[capabilityName]] = isJsonStringifySuccessful(capability, {formatted: true})
                }
                else{
                    ctrlCapabilitiesAttributes[capabilityName] = {}
                    let attributes = capability['attributes'];

                    ctrlCapabilitiesAttributes[capabilityName]["attributes"] = {}

                    for (let index in attributes) {
                        ctrlCapabilitiesAttributes[capabilityName]["attributes"][index] = {}
                        ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['key'] = attributes[index]['key']

                        if (attributes[index].hasOwnProperty('values')) {
                            ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['values'] = JSON.parse(JSON.stringify(attributes[index]['values']))
                            ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['customValue'] = ''

                            controlCapabilitySelectedValueType[attributes[index]['key']] = "values"
                        }
                        if (attributes[index].hasOwnProperty('intValues')) {
                            ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['intValues'] = JSON.parse(JSON.stringify(attributes[index]['intValues']))
                            ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['customValue'] = ''

                            controlCapabilitySelectedValueType[attributes[index]['key']] = "intValues"
                        }
                        if (attributes[index].hasOwnProperty('range')) {
                            ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['range'] = JSON.parse(JSON.stringify(attributes[index]["range"]))
                        
                            controlCapabilitySelectedValueType[attributes[index]['key']] = "range"
                        }
                    }
                }
            }
        }

        if (deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities) {
            let controlCapabilities = deviceModelsMetadata.categories[productCategory].controlCapabilities

            for (let capabilityName in controlCapabilities) {

                if (ctrlCapabilitiesAttributes.hasOwnProperty(capabilityName)) {
                    continue;
                }

                ctrlCapabilitiesAttributes[capabilityName] = {}
                let attributes = controlCapabilities[capabilityName]['attributes'];

                ctrlCapabilitiesAttributes[capabilityName]["attributes"] = {}

                for (let index in attributes) {
                    ctrlCapabilitiesAttributes[capabilityName]["attributes"][index] = {}
                    ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['key'] = attributes[index]['key'] ? attributes[index]['key'] : ""

                    if (attributes[index].valueType==='values') {
                        ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['values'] = []
                    }

                    if (attributes[index].valueType==='intValues') {
                        ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['intValues'] = []
                    }

                    if (attributes[index].valueType==='range') {
                        ctrlCapabilitiesAttributes[capabilityName]["attributes"][index]['range'] = JSON.parse(JSON.stringify(attributes[index]["range"]))
                    }

                    if (attributes[index].valueType instanceof Object && Array.isArray(attributes[index].valueType)) {

                        for (let valueIndex in attributes[index].valueType) {
                            let valueName = attributes[index].valueType[valueIndex]

                            if (valueName==='values') {
                                ctrlCapabilitiesAttributes[capabilityName]["attributes"][index][valueName] = []
                            }
        
                            if (valueName==='intValues') {
                                ctrlCapabilitiesAttributes[capabilityName]["attributes"][index][valueName] = []
                            }
        
                            if (valueName==='range') {
                                ctrlCapabilitiesAttributes[capabilityName]["attributes"][index][valueName] = JSON.parse(JSON.stringify(attributes[index][valueName]))
                            }
                        }
                    }
                }
            }
        }
        setControlCapabilitiesAttributes(ctrlCapabilitiesAttributes)

    }, [productCategory, editDeviceModel, isDeviceModelAddedUsingFileUpload])

    useEffect(() => {
        if (editDeviceModel || isDeviceModelAddedUsingFileUpload) {
            let addedControlCapabilitiesList = []
            for (let controlCapability of deviceModelData['controlCapabilities']) {
                addedControlCapabilitiesList.push(controlCapability['capability'])
            }

            setAddedControlCapabilities(addedControlCapabilitiesList)
            setControlCapabiltiesList((prevState) => {
                // return prevState.filter((capabilityName) => !(addedControlCapabilitiesList.includes(capabilityName))).sort()
                return prevState.filter((capabilityName) => !(addedControlCapabilitiesList.includes(capabilityName)))
            })
        }
        else {
            // setControlCapabiltiesList(deviceModelsMetadata["categories"][productCategory] ? Object.keys(deviceModelsMetadata["categories"][productCategory]["controlCapabilities"]) : [])
            setControlCapabiltiesList(() => {
            const capabilities =
                deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities
                ? Object.keys(
                    deviceModelsMetadata.categories[productCategory].controlCapabilities
                    ).sort()
                : [];

            return [
                customCapabilityName,
                ...capabilities.filter(cap => cap !== customCapabilityName),
            ];
            });
            setAddedControlCapabilities([])
        }

    }, [productCategory, editDeviceModel, isDeviceModelAddedUsingFileUpload])

    useEffect(() => {
        let nextSelectedCapability = ""
        if (controlCapabiltiesList && controlCapabiltiesList.length > 0) {
            nextSelectedCapability = controlCapabiltiesList[0]
        }
        setSelectedControlCapability(nextSelectedCapability)
    }, [controlCapabiltiesList])


    useEffect(() => {
        if (triggerAddNewDeviceModel) {
            let controlCapabilitiesData = getControlCapabilityData();
            addDeviceControlCapabilties(controlCapabilitiesData)
            areAllCustomJsonValidCheck(areAllCustomJsonValid(errors), "control")
        }
    }, [triggerAddNewDeviceModel])

    function handleSelectControlCapability(selectedCapability) {
        setSelectedControlCapability(selectedCapability)
    }

    function handleAddControlCapability(addedCapabilityName) {        
        if(addedCapabilityName === customCapabilityName){
            addedCapabilityName = addedCapabilityName + customCapabilityCount;

            setControlCapabilitiesAttributes(prev => ({
                ...prev,
                [addedCapabilityName]: isJsonStringifySuccessful({}, {formatted: true})
            }));

            setAddedControlCapabilities((prevState) => {
                return [...prevState, addedCapabilityName]
            })

            setCustomCapabilityCount((prev) => prev + 1);
        }
        else{
            setAddedControlCapabilities((prevState) => {
                return [...prevState, addedCapabilityName]
            })

            setControlCapabiltiesList((prevState) => {
                // return prevState.filter((capabilityName) => capabilityName!==selectedControlCapability).sort()
                return prevState.filter((capabilityName) => capabilityName!==selectedControlCapability)
            })
        }
    }

    const isCustomCapability = (value) => value.startsWith(customCapabilityName);

    function handleRemoveControlCapability(removedCapabilityName) {
        // handle custom removal logic
        if ( (isCustomCapability(removedCapabilityName)) || !((deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities) && ([removedCapabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities)) ) {
            setControlCapabilitiesAttributes(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });

            setAddedControlCapabilities((prevState) => {
                return prevState.filter((capabilityName) => capabilityName!==removedCapabilityName).sort()
            })

            setErrors(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });

            setTouched(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });

        } else {
            // handle backend capability removal
            setAddedControlCapabilities((prevState) => {
                return prevState.filter((capabilityName) => capabilityName!==removedCapabilityName).sort()
            })

            setControlCapabiltiesList((prevState) => {
                return [...prevState, removedCapabilityName]
            })
        }
    }

    function handleControlCapabilitiesAttributes(capabilityAttributes) {
        setControlCapabilitiesAttributes(capabilityAttributes)
    }

    function onChangeAttributeKeyName(capabilityName, attributeIndex, keyName) {
        let capabilityAttributes = { ...controlCapabilitiesAttributes }
        capabilityAttributes[capabilityName]["attributes"][attributeIndex]["key"] = keyName

        handleControlCapabilitiesAttributes(capabilityAttributes)
    }

    function onChangeAttributeValues(capabilityName, attributeIndex, values) {
        let capabilityAttributes = { ...controlCapabilitiesAttributes }
        let customValue = capabilityAttributes[capabilityName]["attributes"][attributeIndex]['customValue']
        if (customValue && customValue.length!==0) {
            values.push(customValue)
        }

        capabilityAttributes[capabilityName]["attributes"][attributeIndex]["values"] = values

        handleControlCapabilitiesAttributes(capabilityAttributes)
    }

    function onChangeAttributeIntValues(capabilityName, attributeIndex, values) {
        let capabilityAttributes = { ...controlCapabilitiesAttributes }

        capabilityAttributes[capabilityName]["attributes"][attributeIndex]["intValues"] = values

        handleControlCapabilitiesAttributes(capabilityAttributes)
    }

    function onChangeAttributeCustomValue(capabilityName, attributeIndex, value) {
        let capabilityAttributes = { ...controlCapabilitiesAttributes }

        capabilityAttributes[capabilityName]["attributes"][attributeIndex]["customValue"] = value

        handleControlCapabilitiesAttributes(capabilityAttributes)
    }

    function onChangeAttributeRangeValue(capabilityName, attributeIndex, rangeName, rangeValueIndex, value) {
        let capabilityAttributes = { ...controlCapabilitiesAttributes }
        capabilityAttributes[capabilityName]["attributes"][attributeIndex]['range'][rangeName][rangeValueIndex]['value'] = value

        handleControlCapabilitiesAttributes(capabilityAttributes)
    }

    function onChangeAttributeRangeUnit(capabilityName, attributeIndex, rangeName, rangeValueIndex, uintName) {
        let capabilityAttributes = { ...controlCapabilitiesAttributes }
        capabilityAttributes[capabilityName]["attributes"][attributeIndex]['range'][rangeName][rangeValueIndex]['unit'] = uintName

        handleControlCapabilitiesAttributes(capabilityAttributes)
    }

    function onChangeCapabilityCustomJson(capabilityName, value) {
        let capabilityAttributes = { ...controlCapabilitiesAttributes }

        capabilityAttributes[capabilityName] = value

        handleControlCapabilitiesAttributes(capabilityAttributes)

        const error = validateJSONData(value);
        setErrors((prev) => ({ ...prev, [capabilityName]: error }));
        if (error && error !== "") {
            setTouched((prev) => ({ ...prev, [capabilityName]: "true" }));
        }
    }

    function getControlCapabilitySupportedDeviceTypes(capabilityName) {
        let capability = deviceModelsMetadata['categories'][productCategory]['controlCapabilities'][capabilityName];

        if (capability.hasOwnProperty('supportedDeviceTypes')) {
            let supportedDeviceTypes = capability['supportedDeviceTypes']

            return supportedDeviceTypes.filter((deviceType) => {
                return channelAndSwitchDeviceTypes.includes(deviceType)!==false
            })
        }
        else {
            return channelAndSwitchDeviceTypes;
        }
    }

    function getControlCapabilityData() {
        let controlCapabilities = []
        let uniqueKeys = {};
        for (let capabilityName of addedControlCapabilities) {
            if( (isCustomCapability(capabilityName)) || !((deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities) && ([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities)) ){
                if(isJsonParseSuccessful(controlCapabilitiesAttributes[capabilityName], { logError: false }) !== false){
                    controlCapabilities.push(isJsonParseSuccessful(controlCapabilitiesAttributes[capabilityName]))
                }
            }
            else{
                let capabilityData = {}
                capabilityData['capability'] = capabilityName
                capabilityData['attributes'] = []

                if (productCategory===customConfig.deviceCategorySWITCHES) {
                    capabilityData['devices'] = getControlCapabilitySupportedDeviceTypes(capabilityName)
                }

                let attributes = controlCapabilitiesAttributes[capabilityName]['attributes'];
                for (let index in attributes) {
                    let attributeData = {}
                    attributeData['key'] = attributes[index]['key']

                    // if (uniqueKeys.hasOwnProperty(attributes[index]['key'])) {
                    //     controlCapabilities = {}
                    //     controlCapabilities['error'] = 'Control Capabilities Cannot Have the Same Key Name'
                    //     return controlCapabilities;
                    // }

                    uniqueKeys[attributes[index]['key']] = "";

                    if (attributes[index].hasOwnProperty('values')) {
                        attributeData['values'] = attributes[index]['values']

                        let customValue = attributes[index]['customValue']
                        if (customValue && customValue.length!==0 && !isNaN(customValue)) {
                            attributeData['values'].push(customValue)
                        }
                    }
                    else if (attributes[index].hasOwnProperty('intValues')) {
                        attributeData['intValues'] = attributes[index]['intValues']

                        let customValue = attributes[index]['customValue']
                        if (customValue && customValue.length!==0 && !isNaN(customValue)) {
                            attributeData['intValues'].push(parseInt(customValue))
                        }
                    }
                    else if (attributes[index].hasOwnProperty('range')) {
                        attributeData['range'] = attributes[index]['range']
                    }

                    capabilityData['attributes'].push(attributeData)
                }

                controlCapabilities.push(capabilityData)
            }
        }

        return controlCapabilities;
    }

    function onChangeControlCapabilitySelectedValueType(capabilityName, key, valueTypeSelected) {

        let previousSelectedValueType = controlCapabilitySelectedValueType

        setControlCapabilitySelectedValueType((prevState) => {
            return {
                ...prevState,
                [key]: valueTypeSelected
            }
        })

        let capabilityAttributes = { ...controlCapabilitiesAttributes }

        // get information from metdata
        let metadataAttributes = deviceModelsMetadata['categories'][productCategory]['controlCapabilities'][capabilityName]['attributes']
        for (let index in metadataAttributes) {

            if (metadataAttributes[index].valueType instanceof Object && Array.isArray(metadataAttributes[index].valueType)
            ) {
                for (let attr in capabilityAttributes[capabilityName]["attributes"][index]) {

                    // delete those unnecessary attributes
                    if (!['key', valueTypeSelected].includes(attr)) {
                        delete capabilityAttributes[capabilityName]["attributes"][index][attr];
                    }
                }
            }
        }

        // add those attributes which are not part of capability attributes that are deleted earlier
        for (let index in capabilityAttributes[capabilityName]["attributes"]) {
            if (!capabilityAttributes[capabilityName]["attributes"][index].hasOwnProperty(valueTypeSelected)) {

                for (let metaAttrIndex in metadataAttributes) {

                    if (metadataAttributes[metaAttrIndex].hasOwnProperty(valueTypeSelected)) {

                        capabilityAttributes[capabilityName]["attributes"][index][valueTypeSelected] =
                            metadataAttributes[metaAttrIndex][valueTypeSelected]

                        break
                    }
                }
            }
        }
        setControlCapabilitiesAttributes(capabilityAttributes)
    }

    return (
        <Fragment>
            <div className="row">
                <Box className="s4 col" sx={capabilityListDropdownSx}>
                    <label className="title d-inline  min-180 mb-5 mt-20">Select Capability</label>
                    <Select
                        value={selectedControlCapability}
                        onChange={(e) => {
                            handleSelectControlCapability(e.target.value)
                        }}
                        displayEmpty
                        input={<OutlinedInput />}
                        inputProps={{ 'aria-label': 'Without label' }}
                        sx={selectInputSx}
                        MenuProps={selectMenuProps}
                    >
                        {/* {
                            controlCapabiltiesList?.sort().map((capabilityName) => {
                                return <MenuItem key={capabilityName} value={capabilityName}>{convertCapabilityName(capabilityName)}</MenuItem>
                            })
                        } */}
                        {
                            controlCapabiltiesList?.map((capabilityName) => {
                                return <MenuItem key={capabilityName} value={capabilityName}>{convertCapabilityName(capabilityName)}</MenuItem>
                            })
                        }
                    </Select>
                </Box>
                <div className={`s4 col`}>
                    <button
                        className="btn btn-style-2 orange-bg mr-5" style={addCapabilityButtonSx}
                        onClick={() => {
                            handleAddControlCapability(selectedControlCapability)
                        }}
                        disabled={controlCapabiltiesList && controlCapabiltiesList.length===0}
                    >
                        Add Capability
                    </button>
                </div>
            </div>
            {
                addedControlCapabilities.map((capabilityName) => {
                    return <Fragment key={productCategory + '_' + capabilityName}>
                        <Card variant="outlined" sx={capabilityCardSx} key={capabilityName}>
                            {(isCustomCapability(capabilityName)
                                || !((deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities) && ([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities))
                            ) ?
                            <CardContent>
                                <Grid2 container alignItems="flex-start" spacing={1}>
                                    <Grid2 size={10} sx={{margin: 'auto'}}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                        {CONFIG?.customJson?.label}
                                        </Typography>
                                    </Grid2>

                                    <Grid2 size={2} display="flex" justifyContent="flex-end">
                                        <IconButton
                                        aria-label="delete"
                                        onClick={() => handleRemoveControlCapability(capabilityName)}
                                        sx={{ p: 0.5 }}
                                        >
                                        <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Grid2>

                                    <FormInput
                                        id={capabilityName}
                                        name={capabilityName}
                                        type="textarea"
                                        multiline
                                        rows={CONFIG?.customJson?.rows}
                                        fullWidth
                                        value={controlCapabilitiesAttributes[capabilityName]}
                                        onChange={(e) => onChangeCapabilityCustomJson(capabilityName, e.target.value)}
                                        placeholder={CONFIG?.customJson?.placeholder}
                                        error={!!errors?.[capabilityName]}
                                        touched={touched[capabilityName]}
                                        helperText={errors?.[capabilityName] || CONFIG?.customJson?.helpText}
                                        sx={{
                                        "& .MuiOutlinedInput-input": {
                                            padding: "2px 6pxpx !important",
                                            height: "130px !important",
                                        },
                                        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderWidth: `2px solid !important`,
                                        },
                                        }}
                                        slotProps={{
                                            htmlInput: {
                                                maxLength: 10000,
                                            },
                                        }}
                                    />
                                </Grid2>
                            </CardContent>
                            :
                            <CardContent>
                                <Grid container xs={12}>
                                    <Grid item xs={11}>
                                        <Typography style={{ fontWeight: 600 }}>{convertCapabilityName(capabilityName)}</Typography>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton aria-label="delete" onClick={(e) => {
                                            handleRemoveControlCapability(capabilityName)
                                        }} sx={deleteCapabilityCardButtonSx}>
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                {deviceModelsMetadata?.categories?.[productCategory]?.controlCapabilities?.[capabilityName]?.attributes?.map((element, index) => {
                                    return <Grid key={capabilityName + '_' + index} container>
                                        <Grid item xs={1}>
                                            <Typography style={{ fontSize: "0.85rem", fontWeight: 400 }}>Attribute</Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={attributeKeySx}>
                                            <input
                                                placeholder="Enter Key Name"
                                                className="add-input xl"
                                                value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.key}
                                                type="text"
                                                disabled={true}
                                                onChange={(e) => {
                                                    onChangeAttributeKeyName(capabilityName, index, e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        {
                                            element.valueType === 'values' &&
                                            <Fragment>
                                                <Grid item xs={4}>
                                                    <FormControl variant="outlined" sx={attributeValuesSx}>
                                                        <InputLabel id="select-outlined-label-values">Values</InputLabel>
                                                        <Select
                                                            labelId="select-outlined-label-values"
                                                            id="select-outlined-values-id"
                                                            value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.values || []}
                                                            multiple
                                                            onChange={(e) => {
                                                                onChangeAttributeValues(capabilityName, index, e.target.value)
                                                            }}
                                                            label="Values"
                                                            renderValue={(selected) => selected.join(', ')}
                                                            disabled={element.editable == false ? true : false}
                                                            sx={selectInputSx}
                                                            MenuProps={selectMenuProps}
                                                        >
                                                            {Array.isArray(element?.values) && element?.values.map((listVal) => (
                                                                <MenuItem key={listVal} value={listVal}>
                                                                    <Checkbox checked={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.values?.indexOf(listVal) > -1} />
                                                                    <ListItemText primary={listVal} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                {
                                                    element.addCustomValue===true && <Grid item xs={4}>
                                                        <input
                                                            placeholder="Enter New Value (if any)"
                                                            className="add-input xl"
                                                            style={customValueKeySx}
                                                            value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.customValue}
                                                            type="text"
                                                            onChange={(e) => {
                                                                onChangeAttributeCustomValue(capabilityName, index, e.target.value)
                                                            }}
                                                        />
                                                    </Grid>
                                                }
                                            </Fragment>
                                        }
                                        {
                                            element.valueType === 'intValues' &&
                                            <Fragment>
                                                <Grid item xs={4}>
                                                    <FormControl variant="outlined" sx={attributeValuesSx}>
                                                        <InputLabel id="select-outlined-label-intValues">Values</InputLabel>
                                                        <Select
                                                            labelId="select-outlined-label-intValues"
                                                            id="select-outlined-intValues-id"
                                                            value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.intValues}
                                                            multiple
                                                            onChange={(e) => {
                                                                onChangeAttributeIntValues(capabilityName, index, e.target.value)
                                                            }}
                                                            label="Values"
                                                            renderValue={(selected) => selected.join(', ')}
                                                            disabled={element.editable == false ? true : false}
                                                            sx={selectInputSx}
                                                            MenuProps={selectMenuProps}
                                                        >
                                                            {Array.isArray(element?.intValues) && element?.intValues.map((value) => (
                                                                <MenuItem key={value} value={value}>
                                                                    <Checkbox checked={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.intValues?.indexOf(value) > -1} />
                                                                    <ListItemText primary={value} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                {
                                                    element.addCustomValue===true && <Grid item xs={4}>
                                                        <input
                                                            placeholder="Enter New Value (if any)"
                                                            className="add-input xl" style={customValueKeySx}
                                                            //style={{marginLeft: "20px"}}
                                                            value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.customValue}
                                                            type="text"
                                                            onChange={(e) => {
                                                                onChangeAttributeCustomValue(capabilityName, index, e.target.value)
                                                            }}
                                                        />
                                                    </Grid>
                                                }
                                            </Fragment>
                                        }
                                        {
                                            element.valueType === 'range' &&
                                            <Fragment>
                                                <Grid container xs={6}>
                                                    <Typography>Range</Typography>
                                                    {
                                                        Object.keys(element.range).map((rangeName) => {
                                                            return <Grid key={rangeName} container xs={12}>
                                                                <Grid item xs={12}>
                                                                    <Typography>{rangeName}</Typography>
                                                                </Grid>
                                                                <Grid container xs={12}>
                                                                    {
                                                                        element.range[rangeName].map((rangeValue, rangeValueIndex) => {
                                                                            return <Fragment key={rangeValueIndex}>
                                                                                <Grid item xs={4} sx={attributeKeySx}>
                                                                                    <input
                                                                                        placeholder="Enter Value"
                                                                                        className="add-input xl"
                                                                                        value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.range[rangeName][rangeValueIndex].value}
                                                                                        type="text"
                                                                                        onChange={(e) => {
                                                                                            onChangeAttributeRangeValue(capabilityName, index, rangeName, rangeValueIndex, e.target.value)
                                                                                        }}
                                                                                        disabled={element.editable===false ? true : false}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={4} sx={attributeKeySx}>
                                                                                    {
                                                                                        rangeValue.hasOwnProperty('unit') &&

                                                                                        <input
                                                                                            placeholder="Enter Uint"
                                                                                            className="add-input xl"
                                                                                            value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.range[rangeName][rangeValueIndex].unit}
                                                                                            type="text"
                                                                                            onChange={(e) => {
                                                                                                onChangeAttributeRangeUnit(capabilityName, index, rangeName, rangeValueIndex, e.target.value)
                                                                                            }}
                                                                                            disabled={element.editable===false ? true : false}
                                                                                        />
                                                                                    }
                                                                                </Grid>
                                                                            </Fragment>
                                                                        })
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        })
                                                    }
                                                </Grid>
                                            </Fragment>
                                        }
                                        {
                                            (element.valueType instanceof Object && Array.isArray(element.valueType)) &&
                                            <Fragment>
                                                <Grid item xs={4}>
                                                    <FormControl variant="outlined" sx={attributeValuesSx}>
                                                        <InputLabel id="select-outlined-label-values-types-array">Value Type</InputLabel>
                                                        <Select
                                                            labelId="select-outlined-label-values-types-array"
                                                            id="select-outlined-values-id-values-types-array"
                                                            value={controlCapabilitySelectedValueType?.[element?.key]}
                                                            onChange={(e) => {
                                                                onChangeControlCapabilitySelectedValueType(capabilityName, element.key, e.target.value)
                                                            }}
                                                            label="Value Type"
                                                            sx={selectInputSx}
                                                            MenuProps={selectMenuProps}
                                                        >
                                                            {Array.isArray(element?.valueType) && element?.valueType.map((valueTypeElement, index) => (
                                                                <MenuItem key={valueTypeElement} value={valueTypeElement}>
                                                                    <ListItemText primary={valueTypeElement} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                {
                                                    controlCapabilitySelectedValueType[element.key]==='intValues' &&
                                                    <Grid item xs={4} style={{ marginLeft: "20px" }}>
                                                        <FormControl variant="outlined" sx={attributeValuesSx}>
                                                            <InputLabel id="select-outlined-label-intValues">Values</InputLabel>
                                                            <Select
                                                                labelId="select-outlined-label-intValues"
                                                                id="select-outlined-intValues-id"
                                                                value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.intValues}
                                                                multiple
                                                                onChange={(e) => {
                                                                    onChangeAttributeIntValues(capabilityName, index, e.target.value)
                                                                }}
                                                                label="Values"
                                                                renderValue={(selected) => selected.join(', ')}
                                                                disabled={element.editable == false ? true : false}
                                                                sx={selectInputSx}
                                                                MenuProps={selectMenuProps}
                                                            >
                                                                {Array.isArray(element?.intValues) && element?.intValues.map((value) => (
                                                                    <MenuItem key={value} value={value}>
                                                                        <Checkbox checked={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.intValues?.indexOf(value) > -1} />
                                                                        <ListItemText primary={value} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                }
                                                {
                                                    controlCapabilitySelectedValueType[element.key]==='range' && <Fragment>
                                                        <Grid container xs={4} style={{ marginLeft: '20px' }}>
                                                            <Typography>Range</Typography>
                                                            {
                                                                Object.keys(element.range).map((rangeName) => {
                                                                    return <Grid key={rangeName} container xs={12}>
                                                                        <Grid item xs={12}>
                                                                            <Typography>{rangeName}</Typography>
                                                                        </Grid>
                                                                        <Grid container xs={12}>
                                                                            {
                                                                                element.range[rangeName].map((rangeValue, rangeValueIndex) => {
                                                                                    return <Fragment key={rangeValueIndex}>
                                                                                        <Grid item xs={4} sx={attributeKeySx}>
                                                                                            <input
                                                                                                placeholder="Enter Value"
                                                                                                className="add-input xl"
                                                                                                value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.range[rangeName][rangeValueIndex].value}
                                                                                                type="text"
                                                                                                onChange={(e) => {
                                                                                                    onChangeAttributeRangeValue(capabilityName, index, rangeName, rangeValueIndex, e.target.value)
                                                                                                }}
                                                                                                disabled={element.editable===false ? true : false}
                                                                                            />
                                                                                        </Grid>
                                                                                        <Grid item xs={4} sx={attributeKeySx}>
                                                                                            {
                                                                                                rangeValue.hasOwnProperty('unit') &&

                                                                                                <input
                                                                                                    placeholder="Enter Uint"
                                                                                                    className="add-input xl"
                                                                                                    value={controlCapabilitiesAttributes[capabilityName]?.attributes?.[index]?.range[rangeName][rangeValueIndex].unit}
                                                                                                    type="text"
                                                                                                    onChange={(e) => {
                                                                                                        onChangeAttributeRangeUnit(capabilityName, index, rangeName, rangeValueIndex, e.target.value)
                                                                                                    }}
                                                                                                    disabled={element.editable===false ? true : false}
                                                                                                />
                                                                                            }
                                                                                        </Grid>
                                                                                    </Fragment>
                                                                                })
                                                                            }
                                                                        </Grid>
                                                                    </Grid>
                                                                })
                                                            }
                                                        </Grid>
                                                    </Fragment>
                                                }
                                            </Fragment>
                                        }
                                    </Grid>
                                })}
                            </CardContent>
                            }
                        </Card>
                    </Fragment>
                })
            }
        </Fragment >
    )
}

const mapStateToProps = (state) => ({
    ModelData: state.getModel
});

export default connect(mapStateToProps)(DeviceModelControlCapability);